import { render, staticRenderFns } from "./thankYou.vue?vue&type=template&id=4a414de9&"
import script from "./thankYou.vue?vue&type=script&lang=js&"
export * from "./thankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports